// Login.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, browserSessionPersistence } from './firebaseConfig'; // Import Firebase auth
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Use navigate for routing

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const login = () => {
    // Thiết lập session persistence trước khi đăng nhập
    auth.setPersistence(browserSessionPersistence) // hoặc browserLocalPersistence tùy nhu cầu
      .then(() => {
        // Sau khi thiết lập persistence, thực hiện đăng nhập
        return signInWithEmailAndPassword(auth, email, password);
      })
      .then((userCredential) => {
        // Đăng nhập thành công, điều hướng đến trang admin
        navigate('/admin');
      })
      .catch((error) => {
        setError('Login failed: ' + error.message);
      });
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center">Admin Login</h2>
      <div className="row justify-content-center">
        <div className="col-md-4">
          <form>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={handleEmailChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={handlePasswordChange}
                required
              />
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={login}
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
